/**
 * Pure summary helpers for PIFCC's persisted validation_results_json contract.
 * PIFCC writes every regular check plus optional decision-driving
 * workaround_rule and attachment_list results under per_check_results.
 */

export function getPifccPerCheck(request) {
  let parsed = request?.validation_results_json;
  try {
    if (typeof parsed === 'string') parsed = JSON.parse(parsed);
  } catch (e) {
    return [];
  }
  if (Array.isArray(parsed)) return parsed;
  return (parsed && parsed.per_check_results) || [];
}

export function countPifccChecks(perCheck) {
  const counts = { passed: 0, rejected: 0, escalated: 0, total: 0 };
  (perCheck || []).forEach((check) => {
    const status = String(check?.status || '').toLowerCase();
    const isSuccessfulRuleWorkaround =
      check?.validation === 'step_rule_selection' && status === 'workaround';
    if (status === 'pass' || isSuccessfulRuleWorkaround) counts.passed += 1;
    else if (status === 'reject') counts.rejected += 1;
    else if (status === 'escalate' || status === 'needs_review') counts.escalated += 1;
    else return; // not_applicable, not_run, error, and unknown statuses are excluded
    counts.total += 1;
  });
  return counts;
}

export function formatPifccValidationSummary(counts) {
  const current = counts || { passed: 0, total: 0 };
  return current.total > 0
    ? `${current.passed}/${current.total} passed`
    : 'No applicable checks reported';
}

export function formatPifccValidationBreakdown(counts) {
  const current = counts || {};
  const parts = [];
  if (current.rejected) parts.push(`${current.rejected} rejected`);
  if (current.escalated) parts.push(`${current.escalated} need review`);
  return parts.join(' · ');
}
